'use client'
import { motion } from 'framer-motion'

export const Transition = ({ children }: { children: React.ReactNode }) => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1, translateX: 0 }}
      exit={{ opacity: 0 }}
      transition={{ ease: 'easeInOut', duration: 0.3 }}
      className='w-full'
    >
      {children}
    </motion.div>
  )
}
